import React from "react";
import {
  Hero,
  Benefits,
  BenefitsTable,
  Disclaimer,
  ContactForm,
  InvestmentCalculatorPlaceholder,
} from "agronomist-ui-components";

import PageTemplate from "../helpers/PageTemplate";
import { getBreadcrumbs } from "../helpers/fakeBreadcrumbs";
import TempShareButtonsComponent from "../helpers/TempShareButtonsComponent";
import { scrollToElement, onContactSubmit } from "../helpers/utils";
import CalculatorPage from "../../components/views/CalculatorPage/CalculatorPage";

import imageUrl from "../assets/images/kredyt_10.png";

const COPY = {
  HERO: {
    breadcrumbs: getBreadcrumbs("Kredyt inwestycyjny na zakup ziemi"),
    title: "Kredyt inwestycyjny na zakup ziemi",
    description:
      "Chcesz kupić grunty rolne i rozwijać potencjał swojego gospodarstwa? Szukasz oferty dopasowanej do profilu Twojej działalności? Mamy sprawdzone rozwiązania!",
    imageUrl,
    button: {
      title: "Sprawdź ofertę",
      onClick: () => scrollToElement("#ofert"),
    },
  },
  BENEFITS: {
    title: "Jakie są korzyści z finansowania?",
    subtitle:
      "Jeśli chcesz kupić ziemię, a brakuje Ci środków, skorzystaj z naszej oferty na finansowanie zakupu gruntów rolnych.",
    benefits: [
      {
        title: "Proste procedury",
        description:
          "Wieloletnie doświadczenie Banku w finansowaniu gospodarstw rolnych",
        icon: "TickRounded",
      },
      {
        title: "Długi okres finansowania",
        description: "Nawet do 30 lat",
        icon: "Calendar",
      },
      {
        title: "Możliwość zastosowania karencji w spłacie kapitału",
        description:
          "Do osiągnięcia zdolności produkcyjnej z przedmiotu inwestycji (maks. 2 lata)",
        icon: "Signposts",
      },
    ],
  },
  BENEFITS2: {
    title: "Jak to działa?",
    subtitle:
      "Kredytomat to prosta i przyjazna wyszukiwarka oferty bankowej ułatwiająca dobór produktów najbardziej dopasowanych do Twoich potrzeb związanych z prowadzeniem gospodarstwa rolnego.",
    benefits: [
      {
        title: "Znajdź produkt spełniający Twoje oczekiwania",
        description:
          "Ustaw interesujące Cię kryteria wyszukiwania, aby otrzymać ofertę jak najbardziej dopasowaną do Twoich potrzeb.",
        icon: "SearchBulb",
      },
      {
        title: "Skontaktuj się z nami",
        description:
          "Zapisz propozycję oferty i pozostaw swoje dane kontaktowe lub odwiedź nas w Oddziale.",
        icon: "MessagesBulb",
      },
      {
        title: "Gotowe! Możesz realizować swoje potrzeby",
        description:
          "Ciesz się ze zrealizowanej inwestycji w Twoim gospodarstwie!",
        icon: "HandBulb",
      },
    ],
    withArrow: true,
  },
  DISCLAIMER: {
    notes: [
      "Niniejszy materiał ma charakter wyłącznie reklamowy i informacyjny oraz nie stanowi oferty w rozumieniu Kodeksu Cywilnego. Ostateczna decyzja o udzieleniu kredytu i warunkach kredytowania uzależniona jest od wewnętrznych przepisów Banku oraz wyniku przeprowadzonej przez Bank analizy zdolności kredytowej Klienta. Świadczenie usług i produktów bankowych następuje na warunkach szczegółowo określonych w umowie zawartej z Klientem. Informacja o produktach i usługach bankowych dostępna jest w regulaminach, taryfie prowizji i opłat, dostępnych w oddziałach Banku oraz na stronie <a href='https://www.bnpparibas.pl'>www.bnpparibas.pl</a>.",
    ],
  },
  BENEFITS_TABLE: {
    footer: {
      text: "Dodatkowo możesz ubezpieczyć uprawy.",
      link: "/kredytomat/wizard/poszukuje-ubezpieczenia/2",
    },
    packages: [
      "Przewagi produktu",
      "Maksymalny okres finansowania",
      "Maksymalna kwota kredytu",
      "Minimalny wkład własny",
      "Zabezpieczenie",
      "Karencja w spłacie kapitału",
      "Częstotliwość spłaty kapitału",
    ],
    features: [
      {
        // isRecommended: true,
        title: "Agro Progres",
        list: [
          "Refinansowanie poniesionych wydatków",
          "30 lat",
          "Brak",
          "10%",
          "Hipoteka na nieruchomości",
          "Do 2 lat",
          "Raty miesięczne lub kwartalne lub półroczne lub roczne",
        ],
        footer: {
          text: "ZAPYTAJ O OFERTĘ",
          onClick: () => {
            window.location.href = `/kredytomat/kontakt?product_url=${
              window.location.pathname
            }&product_name=Agro Progres`;
          },
        },
      },
      // {
      //   title: "Kredyt preferencyjny linia Z",
      //   list: [
      //     "Niskie oprocentowanie",
      //     "15 lat",
      //     "8 mln PLN",
      //     "20%",
      //     "Hipoteka na nieruchomości",
      //     "Do 2 lat",
      //     "Raty miesięczne lub kwartalne lub półroczne lub roczne",
      //   ],
      //   footer: {
      //     text: "ZAPYTAJ O OFERTĘ",
      //     onClick: () => {
      //       window.location.href = `/kredytomat/kontakt?product_url=${window.location.pathname}&product_name=x`;
      //     },
      //   },
      // },
      // {
      //   title: "Kredyt preferencyjny linia MRcsk",
      //   list: [
      //     "Dopłata do kapitału",
      //     "30 lat",
      //     "5 mln PLN",
      //     "10%",
      //     "Hipoteka na nieruchomości",
      //     "Do 2 lat",
      //     "Raty miesięczne lub kwartalne lub półroczne lub roczne",
      //   ],
      //   footer: {
      //     text: "ZAPYTAJ O OFERTĘ",
      //     onClick: () => {
      //       window.location.href = `/kredytomat/kontakt?product_url=${window.location.pathname}&product_name=x`;
      //     },
      //   },
      // },
    ],
  },
};

const KredytyNaZakupGruntow = () => (
  <PageTemplate
    meta={{
      name: "Kredytomat",
      description:
        "Potrzebujesz finansowania, dotknęła Cię klęska żywiołowa, a może szukasz ubezpieczenia dla swojego gospodarstwa rolnego? Pomożemy Ci - Agronomist",
      mediaCoverUrl: imageUrl,
    }}
  >
    <Hero {...COPY.HERO} />
    <Benefits {...COPY.BENEFITS} pt="4rem" pb="4rem" />
    <BenefitsTable id="ofert" {...COPY.BENEFITS_TABLE} />
    <TempShareButtonsComponent />
    <InvestmentCalculatorPlaceholder>
      <CalculatorPage isSeparate />
    </InvestmentCalculatorPlaceholder>
    <Benefits {...COPY.BENEFITS2} pt="4rem" pb="4rem" />
    <Disclaimer {...COPY.DISCLAIMER} />
    <ContactForm onSubmit={onContactSubmit} />
  </PageTemplate>
);

export default KredytyNaZakupGruntow;
